import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * AuthGuard component to protect routes and redirect unauthenticated users
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if authenticated
 * @param {Function} props.onUnauthenticated - Function to call if user is not authenticated
 * @returns {JSX.Element} Protected content or null
 */
const AuthGuard = ({ children, onUnauthenticated }) => {
  const { user, loading } = useAuth();

  // If still loading, show nothing or a loading indicator
  if (loading) {
    return (
      <div className="auth-loading">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // If not authenticated, call the onUnauthenticated function
  if (!user) {
    if (onUnauthenticated) {
      onUnauthenticated();
    }
    return null;
  }

  // If authenticated, render the children
  return <>{children}</>;
};

export default AuthGuard; 